<template>
     <div class="specialistes_container">
         <div class="slider_button_specialistes">
             <button class="prev" @click="previousTestimony"></button>
             <button class="next" @click="nextTestimony"></button>
         </div>

         <div v-for="i in [currentIndexTestimony]" :key="i" class="specialistes_subcontainer">
             <div class="portrait">
                 <img :src="currentImgTestimony">
                 <div class="portrait_text">
                     <div class="descriptif_personne"><h5><strong>{{currentName}}</strong></h5></div>
                     <div class="descriptif_job"><h5>{{ currentJob }}</h5></div>

                 </div>


             </div>
                 <div class="citations">
                            <p v-for="i in currentCitation" :key="i">{{ i }}</p>
                 </div>



         </div>
         <div class="dot_block_specialistes">
             <button @click="changeMyIndex(0)" class="dot dot-active" id="dot_spe_0"></button>
             <button @click="changeMyIndex(1)" class="dot" id="dot_spe_1"></button>
             <button @click="changeMyIndex(2)" class="dot" id="dot_spe_2"></button>
         </div>
    </div>



</template>

<script>
  export default {
       data(){
           return {
               images:["/img/castanet.jpg",
                   "/img/feron-poloni.jpg",
                   "/img/icon/anonymous.svg"
               ],
               name:[
                   "Claire Castanet",
                   "Hélène Féron-Poloni",
                   "Antoine"
               ],
               job:[
                   "Directrice des relations avec les épargnants à l’Autorité des marchés financiers",
                   "Avocate spécialisée dans la défense des épargnants",
                   "Epargnant - victime"
               ],
               citation:[
                   [
                   "Méfiez-vous des offres présentant des rendements mirobolants.",
                   "Ne jamais laisser ses coordonnées téléphoniques sur un formulaire Internet offrant un placement. Les vrais professionnels ne démarchent jamais par téléphone.",
                   "Consulter les mises en garde et les listes noires des sociétés et sites non autorisés sur le site de l'AMF."

               ],[
                   "Ne pas répondre aux propositions non sollicitées, notamment par télèphone.",
                   "Ne jamais virer de l'argent dans des banques situées à l'étranger, même si elles sont réputées et basées en Europe.",
                   "Si vous avez versé de l'argent, demandez le retour des fonds à votre banque le plus rapidement possible."

               ],
                   [
                   "Taper le nom du site dans un moteur de recherche avant d'investir. Repéter l'opération en cours d'investissement.",
                   "Sélectionner des gens qui ont pignon sur rue, vérifier leur identité sur le site de l'AMF et, si possible, les rencontrer physiquement.",
                   "En discuter, au préalable, avec, au minimum, deux amis."
               ],

               ],
               timerTestimony : null,
               currentIndexTestimony : 0,
               currentImgTestimony:'/img/castanet.jpg',
               currentName: 'Claire Castanet',
               currentJob:"Directrice des relations avec les épargnants à l’Autorité des marchés financiers",
               currentCitation: ["Méfiez-vous des offres présentant des rendements mirobolants.","Ne jamais laisser ses coordonnées téléphoniques sur un site de placement car les vrais professionnels ne démarchent jamais par téléphone.","Consultez le listing des mises en garde et listes noires des sociétés et sites non autorisés."],
           };
       },
        /*mounted: function() {
        /*this.startmySlide();
        },*/
      methods:{
          /*startmySlide: function() {
              this.timerTestimony = setInterval(this.nextTestimony, 7000);
          },*/
          nextTestimony(){
              if (this.currentIndexTestimony < 2) {
                  this.currentIndexTestimony+=1;
              }
              else {
                  this.currentIndexTestimony=0;
              }

          },
          previousTestimony(){
              if (this.currentIndexTestimony==0) {
                  this.currentIndexTestimony=2;
              }
              else {
                  this.currentIndexTestimony-=1;
              }

          },
         changeMyIndex(button_index){
              this.currentIndexTestimony = button_index;
              this.changeMyActiveClass(button_index);
          },
          changeMyActiveClass(button_index){
              var dot_spe_0 = document.getElementById('dot_spe_0');
              var dot_spe_1 = document.getElementById('dot_spe_1');
              var dot_spe_2 = document.getElementById('dot_spe_2');


              dot_spe_0.classList.remove('dot-active')
              dot_spe_1.classList.remove('dot-active')
              dot_spe_2.classList.remove('dot-active')

              switch (button_index) {
                  case 0:
                     dot_spe_0.classList.add('dot-active')
                     break;
                  case 1:
                      dot_spe_1.classList.add('dot-active')
                      break;
                  case 2:
                      dot_spe_2.classList.add('dot-active')
                      break;
                  default:
                      console.log("ERROR DOT ACTIVE SPECIALISTS")
                      break;
              }


          }
      },
      watch: {
          currentIndexTestimony: function() {
              this.currentImgTestimony = this.images[Math.abs(this.currentIndexTestimony) % this.images.length];
              this.currentName = this.name[Math.abs(this.currentIndexTestimony) % this.name.length]
              this.currentJob = this.job[Math.abs(this.currentIndexTestimony) % this.job.length]
              this.currentCitation =  this.citation[Math.abs(this.currentIndexTestimony) % this.citation.length]
              this.changeMyActiveClass(this.currentIndexTestimony)
          }

      }
  }




</script>

<style>
.specialistes_container{
    display:flex;
    flex-direction:column;
    height:70vh;
    width:80vw;
    justify-content:center;
    align-items: center;
}


.slider_button_specialistes{
    position:relative;
    top:45%;
    width: 80vw;
    display:flex;
    justify-content: space-between;
}



.specialistes_subcontainer{
    display:flex;
    width:60vw;
    height:60vh;
    justify-content:space-around;
    box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.25);
}

.portrait{
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items:center;
    width:30vw;

}





.citations {
    display: flex;
    flex-direction: column;
    justify-content:space-around;
    align-self:center;
    height:50vh;
    width:20vw;


}


.citations_subcontainer{


}


.portrait_text{
    display:flex;
    flex-direction:column;
    margin:0;
    width:30vw;
    justify-content:center;
    align-items:center;
}


div.portrait img{
    height:auto;
    width:18vw;
    clip-path:circle(38%);
    background-color: #cddbeb;
    }


.descriptif_job{
    width:20vw;
    text-align:center;
}


.descriptif_personne{
    position:relative;
    display:flex;
    align-items:flex-end;
    height:13vh;
    justify-content: flex-end;


}


div.descriptif_personne h5{
   margin-bottom:21px;
   font-style:normal;
}

div.descriptif_job h5{
    margin-top:0;
}



.dot_block_specialistes{
    width:10vw;
    height:5vh;
    margin-top:3vh;
    position:relative;
    display:flex;
    justify-content:space-between;
    align-items:center;

}



@media screen and (max-width:430px){
    .specialistes_container{
        display:flex;
        flex-direction:column;
        align-items: center;
        height:70vh;
        width:90vw;
        margin-bottom: 0vh;
    }

    .specialistes_subcontainer{
        display:flex;
        flex-direction:column;
        width:90vw;
        height:55vh;
        align-items:center;
        justify-content: space-between;

    }

    .portrait{
        display:flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top:0vh;
        height:20vh;
        width:90vw;
    }

    div.portrait img{
        height:auto;
        width:30vw;
        clip-path:circle(40%);
    }

    div.portrait_text h5{
        padding-left:0;

    }


    .portrait_text{
        width:60vw;
        height:15vh;
    }

     .descriptif_personne{
            width:60vw;
            height:100%;
            text-align:center;
            justify-content:center;
              }

     .descriptif_job{
         width:60vw;
         text-align:center;
     }


    .citations {
        display: flex;
        flex-direction: column;
        justify-content:space-around;
        align-items:center;
        width: 60vw;
        height:35vh;
    }

    .dot_block_specialistes{
        width:30vw;
        height:5vh;
        margin-top:3vh;
        position:relative;
        display:flex;
        justify-content:space-between;
        align-items:center;

    }


    .slider_button_specialistes{
        position:relative;
        top:68vh;
        width: 80vw;
        display:flex;
        justify-content: space-between;
    }


}

@media screen and (max-width:600px) and (min-width:431px) {
    .specialistes_container {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 80vh;
        width: 90vw;
        margin-bottom: 5vh;
    }

    .specialistes_subcontainer {
        display: flex;
        flex-direction: column;
        width: 90vw;
        height: 45vh;
        align-items: center;
        justify-content: space-between;

    }

    .portrait {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 2vh;
        height: 20vh;
        width: 80vw;
    }

    div.portrait img {
        /*height: 20vh;*/
        height:auto;
        width: 30vw;
        clip-path:circle(38%);
    }

    div.portrait_text h5 {
        padding-left: 0;

    }


    .portrait_text {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 50vw;
        height: 15vh;
    }

    .descriptif_personne {
        width: 40vw;
        height: 100%;
        text-align: center;
        justify-content: center;
    }

    .descriptif_job {
        width: 40vw;
        text-align: center;
    }


    .citations {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 50vw;
        height: 30vh;
    }
    .dot_block_specialistes{
        width:25vw;
        height:5vh;
        margin-top:3vh;
        position:relative;
        display:flex;
        justify-content:space-between;
        align-items:center;

    }
    .slider_button_specialistes{
        position:relative;
        top:68vh;
        width: 80vw;
        display:flex;
        justify-content: space-between;
    }

}
@media screen and (max-width:1000px) and (min-width:601px){
        .specialistes_container{
            display:flex;
            flex-direction:column;
            align-items: center;
            height:100vh;
            width:90vw;
            margin-bottom: 5vh;
            /*align-items:center;*/
        }

        .specialistes_subcontainer{
            display:flex;
            flex-direction:column;
            width:90vw;
            height:50vh;
            align-items:center;
            justify-content: space-between;

        }

        .portrait{
            display:flex;
            flex-direction: row;
            justify-content: flex-start;
            margin-top:2vh;
            height:20vh;
            width:80vw;
        }

        div.portrait img{
           /*height:20vh;*/
            height:auto;
            width:30vw;
            clip-path:circle(38%);
        }

        div.portrait_text h5{
            padding-left:0;

        }


        .portrait_text{
            position:relative;
            display:flex;
            flex-direction: column;
            justify-content: center;
            width:50vw;
            height:15vh;
        }

        .descriptif_personne{
            width:40vw;
            height:100%;
            text-align:center;
            justify-content: center;
        }

        .descriptif_job{
            width:40vw;
            text-align:center;
        }


        .citations {
            display: flex;
            flex-direction: column;
            justify-content:space-around;
            align-items:center;
            width:40vw;
            height:30vh;
        }
    .dot_block_specialistes{
        width:15vw;
        height:6vh;
        margin-top:3vh;
        margin-bottom:0;
        position:relative;
        display:flex;
        justify-content:space-between;
        align-items:center;

    }
    .slider_button_specialistes{
        position:relative;
        top:64vh;
        width: 80vw;
        display:flex;
        justify-content: space-between;
    }


}



</style>